import TextIcon from '@components/common/TextIcon';
import SectorSelect from '@components/modelSelect/SectorSelect';
import Sector from '@models/Sector';
import * as React from 'react';
import Model from '../../models/Model';

interface ModelWithSectors extends Model {
  sectors: Sector[]
}

export interface IMultiSectorSelectProps {
  model: ModelWithSectors
  params?
  placeholder?: string
}

export default class MultiSectorSelect extends React.Component<IMultiSectorSelectProps> {

  delete(option: Sector) {
    const {model} = this.props;
    model.sectors = (model.sectors || []).filter(o => o.id !== option.id);
    this.setState({})
  }

  onNewRowChange(option: Sector) {
    const {model} = this.props;
    if (!model.sectors) model.sectors = [];
    if (model.sectors.find(s => s.id === option.id)) return;
    model.sectors.push(option);
    this.setState({})
  }

  public render() {
    const {model, placeholder, params} = this.props;
    const sectors = model.sectors || [];
    return <div>
      <div className="row-flex mb-3">
        <SectorSelect
          filterModels={(models) => models.filter(m => !sectors.find(s => s.id === m.id))}
          onChange={(option) => this.onNewRowChange(option)}
          placeholder={placeholder || "Ajouter un secteur"}
          params={params}
        />
      </div>
      <div className="">
        {sectors.map((sector: Sector) => (
          <div key={sector.getElementId()} className="yard-user-deletable mb-2 me-2">
            <div className="row-flex">
              <div className="mx-3">
                <TextIcon leftIcon="fas fa-map-marker-alt">{sector.name}</TextIcon>
              </div>
              <div onClick={() => this.delete(sector)} className="px-3 clear-btn ms-auto pointer me-n2"><i className="text-secondary far fa-times"></i></div>
            </div>
          </div>
        ))}
      </div>
      {sectors.length === 0 && (
        <div className="text-s text-secondary mb-3">Aucun secteur = modèle global (proposé pour tous les contacts)</div>
      )}
    </div>
  }
}
